export default __webpack_public_path__ + "static/media/Roboto-Light.3aff701e.ttf";